<template>
  <div id="cash" v-show="!hidePageView">
    <div class="cash-box">
      <CashHeader></CashHeader>
      <CashPayway></CashPayway>
    </div>
  </div>
</template>
<script>
import CashHeader from './CashHeader.vue';
import CashPayway from './CashPayway.vue';
import { mapGetters } from 'vuex';
export default {
  components: {
    CashHeader,
    CashPayway
  },
  props: {
    paySubmitPageUrl: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters(['hidePageView'])
  }
};
</script>
